export const environment = {
  production: true,
  urlAPI: "/indicacaopremiada/api/api"
};
